import { Box } from 'components'
import styled from 'styled-components'

export const Edit = styled.div`
  cursor: pointer;
`

export const DragHandle = styled.div`
  cursor: grab;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  &:active {
    cursor: grabbing;
  }
`

export const Details = styled(Box)`
  padding: 0 1rem;
  flex: 1;
`

export const Songs = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  flex: 1 1 auto;
`

export const SongData = styled(Box)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
`

export const Title = styled.h4`
  ${({ theme: { colors, breakpoint } }) => `
    color: ${colors('link')};
    margin: 0;
    @media only screen and (max-width: ${breakpoint('md')}) {
      font-size: 0.75rem;
    }
  `}
`

export const Song = styled.li`
  ${({ theme: { colors, defaults } }) => `
    margin: 0.5rem;
    padding: 0.5rem;
    border-radius: ${defaults('radius')};
    border: 1px solid ${colors('chrome')};
    background: ${colors('chrome')};
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.completed{
      background: ${colors('chrome', 0.5)};
      opacity: 0.4;
      ${Title}{
        color: ${colors('text', 0.5)};
      }
    }
  `}
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`
